﻿import { dialog, DialogSize, UrlDialogInfo, app } from "@microsoft/teams-js";
import { TFunction } from "i18next";
import moment from 'moment';
import * as React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { getMessagesList, getScheduledMessagesList } from '../../actions';
import { getBaseUrl } from '../../configVariables';
import { IMessage } from '../ScheduledMessages/scheduledMessages';
import './calendar.scss';
import { Button, Spinner, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { CalendarWorkWeek20Regular, CalendarWeekNumbers20Regular, CalendarDay20Regular, CalendarAgenda20Regular, CalendarToday20Regular, ChevronLeft24Regular, ChevronRight24Regular, ChevronDown16Regular } from '@fluentui/react-icons';
import { initializeTeamsApp } from "../../helpers/teamsApp";


// http://jquense.github.io/react-big-calendar/examples/?path=/story/about-big-calendar--page for documentation on Calendar component

interface IState {
    chosenDate: Date;
    loader: boolean;
    sentEvents: Event[];
    sentMessages: IMessage[];
    scheduledEvents: Event[];
    scheduledMessages: IMessage[];
}

interface Event {
    id: string;
    allDay?: boolean | undefined;
    title?: string;
    start?: Date | undefined;
    end?: Date | undefined;
    resource?: any;
}

interface IViewMenuOption {
    key: string;
    text: string;
    icon: JSX.Element
}

export interface ICommsCalendarProps extends WithTranslation {
    getMessagesList?: any;
    getScheduledMessagesList?: any;
    sentMessages?: any;
    scheduledMessages?: any;
}

class CommsCalendar extends React.Component<ICommsCalendarProps, IState> {
    readonly localize: TFunction;
    teamsAadGroupId: string = "";
    private isOpenTaskModuleAllowed: boolean;
    constructor(props: ICommsCalendarProps) {
        super(props);
        this.localize = this.props.t;
        this.teamsAadGroupId = "";
        this.isOpenTaskModuleAllowed = true;
        this.state = {
            loader: true,
            sentEvents: [],
            sentMessages: this.props.sentMessages,
            scheduledEvents: [],
            scheduledMessages: this.props.scheduledMessages,
            chosenDate: new Date()
        }
    }

    public async componentDidMount() {
        initializeTeamsApp();
        this.props.getScheduledMessagesList().then(() => {
            this.props.getMessagesList();
        });
    }

    public componentWillReceiveProps(nextProps: any) {
        if (this.props !== nextProps) {

            const scheduledMessageEvents: Event[] = nextProps.scheduledMessages.map(function (v: any) {
                var date = new Date(v.scheduledDate);
                return { id: v.id, title: v.title, start: date, end: date, resource: "scheduled" }
            })

            const sentMessageEvents: Event[] = nextProps.sentMessages.map(function (v: any) {
                var date = new Date(v.sentDate);
                return { id: v.id, title: v.title, start: date, end: date, resource: "sent" }
            })

            const events = [...scheduledMessageEvents, ...sentMessageEvents];

            this.setState({
                loader: false,
                sentMessages: nextProps.sentMessages,
                scheduledMessages: nextProps.scheduledMessages,
                scheduledEvents: events
            });
        }
    }

    public onOpenTaskModule = (event: any, url: string, title: string, id?: string) => {
        if (this.isOpenTaskModuleAllowed) {
            this.isOpenTaskModuleAllowed = false;
            const dialogSize: DialogSize = {
                height: 530,
                width: 1000
            }
            const urlDialogInfo: UrlDialogInfo = {
                url: url,
                fallbackUrl: url,
                title: title,
                size: dialogSize
            }

            const submitHandler = (result: dialog.ISdkResponse) => {
                // If the edit button is pressed on the status task module, it will trigger the edit task module to open
                if (result.result === "editing") {
                    this.isOpenTaskModuleAllowed = false;
                    const editUrl = getBaseUrl() + "/newmessage/scheduled/" + id + "?locale={locale}";

                    const urlDialogInfo: UrlDialogInfo = {
                        url: editUrl,
                        fallbackUrl: editUrl,
                        title: this.localize("EditMessage"),
                        size: dialogSize
                    }

                    const innerSubmitHandler = (result: dialog.ISdkResponse) => {
                        this.isOpenTaskModuleAllowed = true;
                        this.props.getScheduledMessagesList();
                        this.props.getMessagesList();
                    }
                    dialog.url.open(urlDialogInfo, innerSubmitHandler)
                }

                this.isOpenTaskModuleAllowed = true;
                this.props.getScheduledMessagesList();
                this.props.getMessagesList();
            };
            dialog.url.open(urlDialogInfo, submitHandler);
        }
    }


    private handleSelectEvent = (event: any) => {
        let url = getBaseUrl() + "/viewstatus/" + event.id + "?locale={locale}";
        this.onOpenTaskModule(null, url, this.localize("ViewStatus"), event.id);
    }

    private handleSelectSlot = (event: any) => {
        const today = new Date();
        const givenDate = new Date(event.start);
        if (givenDate >= today) {
            let url = getBaseUrl() + "/newmessage/?date=" + event.start + "&locale={locale}";
            this.onOpenTaskModule(null, url, this.localize("NewMessage"));
        }
    }

    public eventStyleGetter = (event: Event, start: Date, end: Date, isSelected: boolean) => {
        const scheduled: boolean = event.resource === "scheduled";

        const backgroundColor = scheduled ? "#dce0fa" : "#f3f3f3";
        const border = scheduled ? "1px solid #5b5fc7" : "1px solid #9c9c9c";
        const borderLeft = scheduled ? "4px solid #5b5fc7" : "4px solid #9c9c9c";
        const color = scheduled ? "#3d3e78" : "#575757";
        const eventClass = scheduled ? "rbc-scheduled-message" : "rbc-sent-message";

        var style = {
            backgroundColor: backgroundColor,
            border: border,
            borderLeft: borderLeft,
            color: color,
            fontWeight: 600,
            fontSize: "12px",
            zIndex: 3
        };
        return {
            style: style,
            className: eventClass
        }
    }

    public slotStyleGetter = (date: Date) => {
        const today = new Date();
        if (date > today) {
            var style = {
                cursor: "pointer"
            };
            return {
                style: style,
                className: "rbc-slot-selectable"
            }
        } else {
            return {}
        }
    }

    public dayStyleGetter = (date: Date) => {
        const today = new Date();
        if (date > today) {
            var style = {
                cursor: "pointer"
            };
            return {
                style: style,
                className: "rbc-slot-selectable"
            }
        } else {
            return {}
        }
    }

    public onNavigate = (focusDate: any, view: any, prevOrNext: any) => {
        const max = new Date(moment().add(6, "M").format("YYYY-MM-DDTHH:mm"));
        const min = new Date(moment().subtract(6, "M").format("YYYY-MM-DDTHH:mm"));

        if (focusDate > min && focusDate < max) {
            this.setState({
                chosenDate: focusDate
            })
        }
    }

    getCustomToolbar = (toolbar: any) => {
        const mDate = toolbar.date;
        const view = toolbar.view;
        const label = toolbar.label;

        const goToBack = () => {
            let newDate;
            if (view === "month" || view === "agenda") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 7,
                    1
                );
            } else {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() - 1,
                    1
                );
            }
            toolbar.onNavigate("prev", newDate);
        };

        const goToNext = () => {
            let newDate;
            if (view === "month" || view === "agenda") {
                newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
            } else if (view === "week") {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 7,
                    1
                );
            } else {
                newDate = new Date(
                    mDate.getFullYear(),
                    mDate.getMonth(),
                    mDate.getDate() + 1,
                    1
                );
            }
            toolbar.onNavigate("next", newDate);
        };

        const goToToday = () => {
            const now = new Date();
            mDate.setMonth(now.getMonth());
            mDate.setYear(now.getFullYear());
            mDate.setDate(now.getDate());
            toolbar.onNavigate("current");
        };

        const viewMenuOptions: IViewMenuOption[] = [
            {
                key: 'month',
                text: 'Month',
                icon: (<CalendarWorkWeek20Regular />)
            },
            {
                key: 'week',
                text: 'Week',
                icon: (<CalendarWeekNumbers20Regular />)
            },
            {
                key: 'day',
                text: 'Day',
                icon: (<CalendarDay20Regular />)
            },
            {
                key: 'agenda',
                text: 'Agenda',
                icon: (<CalendarAgenda20Regular />)
            },
        ];

        const onViewChange = (itemValue: string) => {
            toolbar.onView(itemValue);
        }

        return (
            <div className="rbc-toolbar">
                <div className="rbc-btn-group today-btn">
                    <Button icon={<CalendarToday20Regular />} onClick={goToToday}>Today</Button>
                </div>
                <div className='rbc-btn-group chevron-btn'>
                    <Button icon={<ChevronLeft24Regular />} onClick={goToBack} title="Previous" />
                    <Button icon={<ChevronRight24Regular />} onClick={goToNext} title="Next" />
                </div>
                <div className="rbc-toolbar-label">{label}</div>
                <div className="rbc-btn-group menu-btn">
                    <Menu>
                        <MenuTrigger disableButtonEnhancement>
                            <Button icon={viewMenuOptions.find(x => x.key === view)?.icon }>
                                {viewMenuOptions.find(x => x.key === view)?.text}
                                <ChevronDown16Regular style={{marginLeft: "5px"}}/>
                            </Button>
                        </MenuTrigger>

                        <MenuPopover>
                            <MenuList>
                                {viewMenuOptions.map(x => (
                                    <MenuItem icon={x.icon} onClick={(e) => onViewChange(x.key)}>{x.text}</MenuItem>
                                ))}
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </div>
            </div>
        )
    }

    getTimeGutterFormat = (date: any, culture: any, localizer: any) => {
        return localizer.format(date, 'h a', culture);
    }

    getEventTimeRangeFormat = (range: any, culture: any, localizer: any) => {
        return localizer.format(range.start, 'h:mm a', culture);
    }

    public onNewMessage = () => {
        const submitHandler = (result: dialog.ISdkResponse) => {
            this.props.getScheduledMessagesList();
        };

        const urlDialogInfo: UrlDialogInfo = {
            url: getBaseUrl() + "/newmessage/?locale={locale}",
            title: this.localize("NewMessage"),
            size: {
                height: 530,
                width: 1000
            },
            fallbackUrl: getBaseUrl() + "/newmessage/?locale={locale}",
        }

        dialog.url.open(urlDialogInfo, submitHandler);
    }

    public render(): JSX.Element {
        const localizer = momentLocalizer(moment);

        if (this.state.loader) {
            return (
                <div className="calendar-loader">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div>
                    <Calendar
                        localizer={localizer}
                        events={this.state.scheduledEvents}
                        messages={{ event: 'Message', noEventsInRange: 'There are no messages in this range.' }}
                        onSelectEvent={this.handleSelectEvent}
                        onSelectSlot={this.handleSelectSlot}
                        selectable
                        onSelecting={() => false}
                        step={30}
                        timeslots={2}
                        style={{ height: "calc(100vh - 53px)" }}
                        eventPropGetter={this.eventStyleGetter}
                        slotPropGetter={this.slotStyleGetter}
                        dayPropGetter={this.dayStyleGetter}
                        popup={true}
                        date={this.state.chosenDate}
                        onNavigate={this.onNavigate}
                        components={{
                            toolbar: this.getCustomToolbar,
                        }}
                        formats={{
                            timeGutterFormat: this.getTimeGutterFormat,
                            eventTimeRangeFormat: this.getEventTimeRangeFormat
                        }}
                    />
                </div>
            )
        }
    }
}

const mapStateToProps = (state: any) => {
    return { sentMessages: state.messagesList, scheduledMessages: state.scheduledMessages };
}

const commsCalendarWithTranslation = withTranslation()(CommsCalendar);
export default connect(mapStateToProps, { getMessagesList, getScheduledMessagesList })(commsCalendarWithTranslation);